<!-- customizations -->
@if(!environment.production)
{
    <au-ribbon-environment></au-ribbon-environment>
}
<router-outlet></router-outlet>
